import {AbstractJavascriptFunctionCallVO} from "../../../controller/externalInterface/vo/AbstractJavascriptFunctionCallVO";

export class JavascriptCallSetForumHashVO implements AbstractJavascriptFunctionCallVO {
    private static JS_FUNCTION_SET_FORUM_HASH: string = "setForumHash";

    /**
     * Defines parameters needed for calling "setForumLink" javascript function.
     *
     * Full documentation for javascript/flash interface see:
     * https://docs.google.com/a/goodgamestudios.com/spreadsheet/ccc?key=0AtXFx56d9X1adDlYcUtZc3JVdThMQ0NES0pUYlFqMHc#gid=0
     */

    public functionName = JavascriptCallSetForumHashVO.JS_FUNCTION_SET_FORUM_HASH;
    public parameters;

    constructor(forumHash: string) {
        this.parameters = [forumHash];
    }
}
